import AuthSimpleLayout from 'layouts/authentication';
import lightImg from '../../assets/img/spot-illustrations/1.png';
import darkImg from '../../assets/img/spot-illustrations/dark_1.png';
import Button from '../../components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const SignOut = () => {
  return (
    <AuthSimpleLayout logo={false}>
      <div className="text-center mb-6 mx-auto">
        <img className="mb-7 d-dark-none" src={lightImg} alt="stepx" />
        <img className="mb-7 d-light-none" src={darkImg} alt="stepx" />
        <div className="mb-6">
          <h4 className="text-body-highlight">Come back soon!</h4>
          <p className="text-body-tertiary">
            Thanks for using StepX <br className="d-lg-none" />
            You are now successfully signed out.
          </p>
        </div>
        <div className="d-grid">
          <Link to="/sign-in" className="btn btn-primary d-flex align-items-center justify-content-center">
            <FontAwesomeIcon icon={faAngleLeft} className="me-2" />
            Go to sign in page
          </Link>
        </div>
      </div>
    </AuthSimpleLayout>
  );
};

export default SignOut;
